import config from '@/utils/config.js';
export default {
	newLink(url){
		let tempwindow=window.open('_blank'); // 先打开页面
		tempwindow.location=url; 
		// window.open(url, '_blank');
	},
	//加法
	accAdd(arg1, arg2) {
	    var r1, r2, m;
	    try {
	        r1 = arg1.toString().split(".")[1].length
	    } catch (e) {
	        r1 = 0
	    }
	    try {
	        r2 = arg2.toString().split(".")[1].length
	    } catch (e) {
	        r2 = 0
	    }
	    m = Math.pow(10, Math.max(r1, r2))
	    return (arg1 * m + arg2 * m) / m
	},
	//减法 
	subtr(arg1, arg2) {
	    var r1, r2, m, n;
	    try {
	        r1 = arg1.toString().split(".")[1].length
	    } catch (e) {
	        r1 = 0
	    }
	    try {
	        r2 = arg2.toString().split(".")[1].length
	    } catch (e) {
	        r2 = 0
	    }
	    m = Math.pow(10, Math.max(r1, r2));
	    n = (r1 >= r2) ? r1 : r2;
	    return ((arg1 * m - arg2 * m) / m).toFixed(n);
	},
    // 判断传入的值，是否带有单位，如果没有，就默认用px单位
    getUnitValue(val) {
    	if(/(%|px|auto)$/.test(val)) return val;
    	else return val + 'px'
    },
    //数组平分
    setDivideList(list=[]){
        let list1 = [];
        let list2 = [];
		if(list.length){
			list.forEach((item,index)=>{
				index % 2 ? list1.push(item) : list2.push(item)
			})
		}
        return [list1,list2]
    },
    //富文本图片处理
    normalRichText(content) {
        if (!content) return content;
        let ret = content;
        // let keys = '/public_html/upload';
        ret = ret.replace(/<img/g, '<img style=" max-width:100% !important" class="rich-img" ');
       // ret= ret.replace(new RegExp(keys,'g'),config.http+keys);
        return ret;
    },
    imgSlice(src){
        if(~src.indexOf(config.upPrefix)){
            return src.slice(config.upPrefix.length-1,src.length)
        } else{
            return src
        }
    },
    //显示补考  网授线上课程不用 
    showTutorial(info){
         return info.is_exam == config.IS_EXAM && info.type != config.COURSE_TYPE_FACE_NAME && info.exam_type == config.EXAM_TYPE_DOWN || info.is_exam == config.IS_EXAM && info.type == config.COURSE_TYPE_FACE_NAME;
    },
    //接口错误
    apiErr(){
        this.$message.error('系统错误！');
        setTimeout(()=>{
            this.goback();
        },config.timeLoad)
    },
    
    prohibitInit(){
        document.onselectstart=function () { return false; };
        document.oncontextmenu = function () { return false; };
        document.onkeydown = function () {
            if (window.event && window.event.keyCode == 123) {
                event.keyCode = 0;
                event.returnValue = false;
                return false;
            }
        };
    },
    
    removeProhibit(){
        document.onselectstart= ''
        document.oncontextmenu = ''
    }
    
}